import { Box, Button, Grid, InputAdornment, TextField } from "@mui/material";
import { useMemo, useState } from "react";
import { FormattedMessage } from "react-intl";
import { getFlagPathToLocale } from "../utils/lib";

const textFieldStyle = { width: '100%' };

export default function AttributeRegionSelectionValue({ selectedLanguages = [], addValue, id, initialValues }) {

  const [languageValues, setLanguageValues] = useState(selectedLanguages.reduce((acc, key) => {
    if (initialValues) {
      acc[key] = initialValues[key];
    } else {
      acc[key] = '';
    }
    return acc;
  }, {}));

  const languageFields = useMemo(() => {
    return Object.keys(languageValues).map(language => {
      return <Grid item xs={12} key={language} >
        <TextField
          InputLabelProps={{ shrink: true }}
          variant="outlined"
          size="small"
          name={"key " + language}
          label={"Name " + language.toUpperCase()}
          type="text"
          sx={textFieldStyle}
          value={languageValues[language] || ''}
          onChange={(event) => setLanguageValues(old => {
            let obj = { ...old };
            obj[language] = event.target.value
            return obj;
          })}
          required
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <img src={getFlagPathToLocale(language)} style={{ width: 24, height: 16 }} />
              </InputAdornment>
            ),
          }}
          disabled={false}
          inputProps={{ maxLength: 50 }}
        />
      </Grid>
    });
  }, [languageValues]);


  return (
    <Box
      component="form"
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        addValue({ ...languageValues, id })
      }}
    >
      <Grid sx={{ marginTop: 1 }} container spacing={1} >
        {
          languageFields
        }
        <Grid item xs={12} >
          <Button variant="contained" type="submit" > {initialValues ? <FormattedMessage id="EditAttribute.saveValue" /> : <FormattedMessage id="EditAttribute.addValue" />}</Button>
        </Grid>
      </Grid>
    </Box>
  )
}